import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TextField,
  Checkbox,
  Radio,
  Button,
  Stack,
  Box,
  Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export default function PricePropertyValuesEditor({
  values = [],
  onChange,
}) {

  const updateValue = (index, field, value) => {
    const updated = [...values];
    updated[index] = {
      ...updated[index],
      [field]: value
    };

    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...values,
      {
        id: 0,
        name: "",
        artNo: "",
        hasComment: false,
        defaultQuantity: 1,
        isDefault: false,
      }
    ]);
  };

  const deleteRow = (index) => {
    const updated = values.filter((_, i) => i !== index);
    onChange(updated);
  };

  const setDefault = (index) => {
    const currentlyDefault = values[index]?.isDefault;

    const updated = values.map((v, i) => ({
      ...v,
      isDefault: currentlyDefault ? false : i === index
    }));

    onChange(updated);
  };

  const toggleDefault = (index) => {
    const isAlreadyDefault = values[index]?.isDefault;

    const updated = values.map((v, i) => ({
      ...v,
      isDefault: isAlreadyDefault ? false : i === index
    }));

    onChange(updated);
  };

  return (
    <Box>

      <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography variant="subtitle1">
          Egenskapsvärden
        </Typography>

        <Button startIcon={<AddIcon />} onClick={addRow}>
          Lägg till värde
        </Button>
      </Stack>

      <Table size="small">

        <TableHead>
          <TableRow>
            <TableCell>Namn</TableCell>
            <TableCell>Art.nr</TableCell>
            <TableCell>Kommentar</TableCell>
            <TableCell>Antal</TableCell>
            <TableCell>Standard</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {values.map((row, index) => (
            <TableRow key={row.id || index}>

              {/* NAME */}
              <TableCell>
                <TextField
                  size="small"
                  value={row.name}
                  onChange={(e) =>
                    updateValue(index, "name", e.target.value)
                  }
                />
              </TableCell>

              {/* ART NO */}
              <TableCell>
                <TextField
                  size="small"
                  value={row.artNo}
                  onChange={(e) =>
                    updateValue(index, "artNo", e.target.value)
                  }
                />
              </TableCell>

              {/* COMMENT */}
              <TableCell>
                <Checkbox
                  checked={row.hasComment || false}
                  onChange={(e) =>
                    updateValue(index, "hasComment", e.target.checked)
                  }
                />
              </TableCell>

              {/* QUANTITY */}
              <TableCell>
                <TextField
                  size="small"
                  type="number"
                  value={row.defaultQuantity}
                  onChange={(e) =>
                    updateValue(index, "defaultQuantity", e.target.value)
                  }
                />
              </TableCell>

              {/* DEFAULT RADIO */}
              <TableCell align="center">
                <IconButton onClick={() => toggleDefault(index)}>
                  {row.isDefault ? (
                    <CheckCircleIcon sx={{ color: "success.main" }} />
                  ) : (
                      <RadioButtonUncheckedIcon sx={{ color: "action.disabled" }} />
                    )}
                </IconButton>
              </TableCell>

              {/* DELETE */}
              <TableCell>
                <IconButton
                  color="error"
                  onClick={() => deleteRow(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>

            </TableRow>
          ))}
        </TableBody>

      </Table>
    </Box>
  );
}